"use client";
import { FC } from "react";
import s from "./table.module.css";

type Props = {
	data: any;
	columnsNames: any;
};

const Table2: FC<Props> = ({ data, columnsNames }) => {
	const concatedData = columnsNames.concat(data);
	return (
		<div className=' border border-white rounded-[15px] overflow-hidden h-full mt-[50px]'>
			<div className={s.table2}>
				{concatedData.map((el: any, index: number) => (
					<div
						key={index}
						className={`border text-[27px] py-[29px] ${
							index <= 5 && "font-[600]"
						} ${
							index == 6 &&
							"font-[200] text-[23px] text-[rgba(255,255,255,0.84)]"
						} ${
							index <= 2 && "py-[9px]"
						} max-desktop:text-[21px] max-tablet:text-[16px] max-tablet:leading-[14px] max-tablet:px-[5px] max-desktop:leading-[21px] leading-[29px] font-[400] text-center whitespace-pre-line flex items-center justify-center border-white px-[15px] ${
							index === concatedData.length - 1 && s.fullWidth
						}`}>
						{index === 4 ? (
							<a href='mailto:'>{el.text}</a>
						) : index <= 2 ? (
							el.columnName
						) : (
							el.text
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default Table2;
